module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions/12-display-84ef0d5d55d2287c1bb0491e6c457452.png";